import { LinkPaymentDialogItemsController } from "./link-payment-dialog-items.controller";

angular
    .module("thor.online-containers.edit.link-payment-dialog-items.component", [])
    .component("linkPaymentDialogItems", {
        bindings: {
            items: "<",
            saleCurrency: "<"
        },
        controller: LinkPaymentDialogItemsController,
        template: require("./link-payment-dialog-items.html")
    });
